module.exports = __webpack_public_path__ + "img/google.ec63a6a5.svg";